var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ve-histogram',{staticClass:"subCharts",attrs:{"height":"300px","data":_vm.sourceData,"extend":_vm.downChartExtend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }